<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <div class="card">
                <!--<div class="card-header">
                    <h2>Form</h2>
                </div>-->
                <div class="card-body">
                    <div class="row g-xl-5 g-3">
                        <!-- CREAR LOS TABS DEL FORMULARIO -->
                        <div class="col-xxl-3 col-xl-4 box-col-4e sidebar-left-wrapper">
                            <ul class="sidebar-left-icons nav nav-pills" id="add-product-pills-tab" role="tablist">
                                @for (item of addProductTabData; track item) {
                                    <li class="nav-item">
                                        <a class="nav-link" id="{{item.id}}" [class.active]="activeSteps == item.steps" (click)="goToStep(item.steps)">
                                            <div class="nav-rounded">
                                                <div class="product-icons">
                                                    <app-common-svg-icons [class]="'stroke-icon'" [icons]="item.svg"></app-common-svg-icons>
                                                </div>
                                            </div>
                                            <div class="product-tab-content">
                                                <h6>{{item.title}}</h6>
                                                <p>{{item.subTitle}}</p>
                                            </div>
                                        </a>
                                    </li>
                                }
                            </ul>
                        </div>
                        <!-- CREAR LOS FORMULARIOS -->
                        <div class="col-xxl-9 col-xl-8 box-col-8 position-relative">
                            <div class="tab-content" id="add-product-pills-tabContent">
                                <div class="tab-pane " id="vehicle-detail" [ngClass]="activeSteps == 1 ? 'd-block' : 'd-none'">
                                    <div class="sidebar-body">
                                        <app-new-vehicle *ngIf="activeSteps === 1" (activeSteps)="receiveChildData($event)" (dataChanged)="updateData($event)"></app-new-vehicle>
                                    </div>
                                </div>
                                <div class="tab-pane" id="vehicle-procedure" [ngClass]="activeSteps == 2 ? 'd-block' : 'd-none'">
                                    <div class="sidebar-body">
                                        <app-procedure-vehicle *ngIf="activeSteps === 2" (activeSteps)="receiveChildData($event)" [sharedData]="dataFromParent"></app-procedure-vehicle>
                                    </div>
                                </div>
                                <div class="tab-pane" id="vehicle-leasing" [ngClass]="activeSteps == 3 ? 'd-block' : 'd-none'">
                                    <div class="sidebar-body">
                                        <app-leasing-vehicle *ngIf="activeSteps === 3" (activeSteps)="receiveChildData($event)" [sharedData]="dataFromParent"></app-leasing-vehicle>
                                    </div>
                                </div>
                                <div class="tab-pane" id="vehicle-confirmation" [ngClass]="activeSteps == 4 ? 'd-block' : 'd-none'">
                                    <div class="sidebar-body">
                                        <app-confirmation-vehicle *ngIf="activeSteps === 4" (activeSteps)="receiveChildData($event)" [sharedData]="dataFromParent"></app-confirmation-vehicle>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>